var SvgHelper = {};

SvgHelper.create = function (tag, attrs, val) {
  var el = document.createElementNS('http://www.w3.org/2000/svg', tag);
  for (var k in attrs) {
    if (attrs.hasOwnProperty(k)) {
      if (k === 'xlink:href') {
        el.setAttributeNS('http://www.w3.org/1999/xlink', 'href', attrs[k]);
      } else {
        el.setAttribute(k, attrs[k]);
      }
    }
  }
  if (val) {
    var textNode = document.createTextNode(val);
    el.appendChild(textNode);
  }
  return el;
};
